import { api } from "../Apis/interceptor";

export const get = function (id) {
  return api.get("/api/v1/options/" + id);
};

export const admin_addnew = function () {
  return api.get("/api/v1/options");
};

export const list = function () {
  return api.get("/api/v1/optionlist");
};

export const filter = function (skip, limit, pattern, orderBy) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/options_filter", {
    params: { skip: skip, limit: limit, pattern: pattern, orderBy: orderBy },
  });
};

export const getPageLike = function (pattern) {
  return api.get("/api/v1/optionLike/" + pattern);
};

export const create = function (optionData) {
  return api.post("/api/v1/options/", optionData);
};

export const update = function (id, optionData) {
  return api.put("/api/v1/options/" + id, optionData);
};

export const delete1 = function (id) {
  return api.delete("/api/v1/options/" + id);
};

export const getStages = function () {
  return api.get("/api/v1/optionsStages");
};

export const getAll = function (limit, orderBy) {
  return api.get("/api/v1/getAll", {
    params: { limit: limit, orderBy: orderBy },
  });
};
//ctreate rds option
export const createRDS = function (optionData) {
  return api.post("/api/v1/rdsOptions", optionData);
};
//getAll rds data
export const getAllRds = function (limit, orderBy) {
  return api.get("/api/v1/getAllRds", {
    params: { limit: limit, orderBy: orderBy },
  });
};

//get option by using id
export const getRds = function (id) {
  return api.get("/api/v1/rdsOptions/" + id);
};

//get option by using id
export const updateRds = function (id, optionData) {
  return api.put("/api/v1/rdsOptions/" + id, optionData);
};

//delete option
export const deleteRds = function (id) {
  return api.delete("/api/v1/rdsOptions/" + id);
};
//filter
export const filterRds = function (skip, limit, pattern, orderBy) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/rds_options_filter", {
    params: { skip: skip, limit: limit, pattern: pattern, orderBy: orderBy },
  });
};
